import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { verifyLogin } from "../../api/api-autenticacion";
import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";
import { VERSION_COMPRARTODO } from "../../utils/const/version-const";
import AuthPageShell, { AuthFormCard } from "../../components/ecommerce/AuthPageShell";
import { EC } from "../../utils/const/ecommerce-colors-const";
import { sharedInsertInfo } from "../../utils/shared-functions";
import { STRING_SIDEBAR_EXPANDED_COMPRARTODO } from "../../utils/const/string-const";

export default function Login() {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const [usuario, setUsuario] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        // console.log("Login");
    }, []);

    const submit = async (e) => {
        try {
            e.preventDefault();
            setLoading(true);
            const response = await verifyLogin(usuario, password);
            setLoading(false);
            if (response.error === false) {
                localStorage.setItem(STRING_SIDEBAR_EXPANDED_COMPRARTODO, true);
                sharedInsertInfo(response);
                const redirectParam = new URLSearchParams(location.search).get("redirect");
                const redirectPath = redirectParam || location.state?.from || "/dashboard";
                history.push(redirectPath);
            } else {
                alert(response.message);
            }
        } catch (err) {
            console.log("submit err", err);
            setLoading(false);
        }
    };

    return (
        <AuthPageShell
            badge={t("label_iniciar_sesion")}
            badgeIcon="🔐"
            title={t("ct_brand")}
            subtitle={t("ct_login_subtitle")}
        >
            <AuthFormCard>
                <form onSubmit={submit} className="space-y-6">
                    <div>
                        <h2 className="text-xl font-bold text-slate-900 mb-1">{t("label_iniciar_sesion")}</h2>
                        <p className="text-sm text-slate-600">{t("label_ingresa_tus_credenciales_para_continuar")}</p>
                    </div>

                    <div>
                        <label htmlFor="usuario_login" className={EC.form.label}>
                            {t("label_usuario")}
                        </label>
                        <input
                            id="usuario_login"
                            type="text"
                            value={usuario}
                            onChange={(e) => setUsuario(e.target.value)}
                            className={EC.form.input}
                            placeholder={t("label_ingresa_tu_usuario")}
                            required
                            disabled={loading}
                            autoComplete="username"
                        />
                    </div>

                    <div>
                        <label htmlFor="password_login" className={EC.form.label}>
                            {t("label_contrasena")}
                        </label>
                        <div className="relative">
                            <input
                                id="password_login"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={`${EC.form.input} pr-12`}
                                placeholder={t("label_ingresa_tu_contrasena")}
                                required
                                disabled={loading}
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-ct-primary-600 focus:outline-none transition-colors"
                                disabled={loading}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" disabled={loading} className={EC.form.submit}>
                        {loading ? (
                            <>
                                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden>
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                </svg>
                                {t("label_cargando")}
                            </>
                        ) : (
                            t("label_ingresar")
                        )}
                    </button>

                    <div className="pt-4 border-t border-slate-100 text-center space-y-3">
                        <p className="text-sm text-slate-600">
                            {t("ct_signup_no_account")}{" "}
                            <button
                                type="button"
                                onClick={() => {
                                    history.push("/sign-up");
                                }}
                                className="font-semibold text-ct-primary-700 hover:text-ct-primary-800"
                            >
                                {t("ct_signup_title")}
                            </button>
                        </p>
                        <p className="text-xs text-slate-500">version {VERSION_COMPRARTODO}</p>
                    </div>
                </form>
            </AuthFormCard>

            <div className="mt-6 text-center">
                <button type="button" onClick={() => history.push("/landing")} className={EC.form.link}>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    {t("label_volver_al_inicio")}
                </button>
            </div>
        </AuthPageShell>
    );
}
